export default function initFileUpdate() {
  // --- Lógica de Troca de Formulários (Tabs) ---
  const tabButtons = document.querySelectorAll('.c-contato__forms-btn');
  const tabContents = document.querySelectorAll('.c-contato__forms-content');

  if (tabButtons.length > 0) {
    tabButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const targetId = btn.getAttribute('data-form-target');

        tabButtons.forEach(b => b.classList.remove('is-active'));
        tabContents.forEach(c => c.classList.remove('is-visible'));

        btn.classList.add('is-active');
        const targetContent = document.getElementById(targetId);
        if (targetContent) targetContent.classList.add('is-visible');
      });
    });
  }

  // --- Lógica de Nome do Arquivo Selecionado ---
  const inputFile = document.getElementById('js-file-input');
  const fileNameDisplay = document.getElementById('js-file-name');

  if (inputFile && fileNameDisplay) {
    inputFile.addEventListener('change', function () {
      if (this.files.length > 0) {
        fileNameDisplay.textContent = this.files[0].name;
      } else {
        fileNameDisplay.textContent = 'Nenhum arquivo selecionado';
      }
    });
  }
  initTabDrag();
  initFormSuccess();
}

function initTabDrag() {
  const slider = document.querySelector('.c-contato__forms-nav');
  if (!slider) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('is-dragging');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;

    e.preventDefault();
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('is-dragging');
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('is-dragging');
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  });
}

// ... (suas funções initFileUpdate e initTabDrag continuam iguais)

function initFormSuccess() {
  // Listener para SUCESSO
  document.addEventListener('wpcf7mailsent', function (event) {
    const formElement = event.target;
    const container = formElement.closest('.c-contato__forms-content');

    if (container) {
      const formWrapper = container.querySelector('.c-contato__forms-form');
      const successMessage = container.querySelector('.form-success-msg');

      if (formWrapper && successMessage) {
        formWrapper.style.display = 'none';
        successMessage.classList.remove('is-hidden');
        successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, false);

  // Listener para ERROS DE VALIDAÇÃO
  document.addEventListener('wpcf7invalid', function(event) {
    // Usamos o timeout para esperar a renderização do CF7
    setTimeout(() => {
      const firstErrorField = event.target.querySelector('.wpcf7-not-valid');
      if (firstErrorField) {
        // Tenta rolar para o container do erro
        firstErrorField.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }, ); 
  }, false);
}
